/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Contact/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Contact({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Contact",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#DD6161"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Contact.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-S2eks': alignSelf,'--mt-2-S2eks': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-S2eks': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-S2eks': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-S2eks': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-S2eks': opacity,'--w-10-S2eks': typeof width === 'number' ? `${width}px` : width,'--h-11-S2eks': typeof height === 'number' ? `${height}px` : height,'--f-12-S2eks': fill,'--a-7-S2eks': isAnimated ? animation : "none",'--sd-8-S2eks': isAnimated ? strokeDashoffset : 0,'--sd-9-S2eks': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Contact.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M13.361 2H5.198A2.198 2.198 0 003 4.14v9.665A2.198 2.198 0 005.198 16H14.322a.757.757 0 000-1.514h-.203v-1.543a1.715 1.715 0 00.96-1.542V3.718A1.718 1.718 0 0013.361 2zM4.715 14.285a.683.683 0 01.483-1.166h7.407v1.367H5.198a.683.683 0 01-.483-.2zm6.068-3.943a1.718 1.718 0 01-1.064-.09 9.638 9.638 0 01-3.31-3.31 1.727 1.727 0 01.467-1.975l.249-.249a.538.538 0 01.739-.096l.803.803a.538.538 0 01-.097.739.538.538 0 00-.096.739l1.285 1.285a.538.538 0 00.739-.097.538.538 0 01.739-.096l.803.803a.538.538 0 01-.097.739l-.248.249a1.719 1.719 0 01-.912.556z"
 style={{'--f-12-S2eks': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}